export const colors = {
  primary: "#7F77E0",
  secondary: "#7F81E026",
  dark: "#3A354D",
  light: "#9598A6",
};

export const shadows = {
  leftFrame:
    "rgba(127, 119, 224, 0.4) -5px 5px, rgba(127, 119, 224, 0.3) -10px 10px, rgba(127, 119, 224, 0.2) -15px 15px, rgba(127, 119, 224, 0.1) -20px 20px, rgba(127, 119, 224, 0.05) -25px 25px;",
  rightFrame:
    "rgba(127, 119, 224, 0.4) 5px 5px, rgba(127, 119, 224, 0.3) 10px 10px, rgba(127, 119, 224, 0.2) 15px 15px, rgba(127, 119, 224, 0.1) 20px 20px, rgba(127, 119, 224, 0.05) 25px 25px;",
  banner:
    "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 3px 6px -3px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;",
};

export const utils = {
  height: {
    fullVH: "100vh",
    halfVH: "50vh",
    full: "100%",
    half: "50%",
  },
  width: {
    fullVW: "100vw",
    halfVW: "50vw",
    full: "100%",
    half: "50%",
  },
};

export const fonts = {
  xs: "10px",
  sm: "12px",
  md: "16px",
  lg: "20px",
};

export const sizes = {
  xs3: "0.5em",
  xs2: "0.75em",
  xs: "1em",
  sm: "1.25em",
  md: "1.5em",
  lg: "2em",
  xl: "2.5em",
  xl2: "3em",
  xl3: "4em",
  xl4: "5em",
  xl5: "8em",
};

export const weights = {
  light: 300,
  regular: 400,
  semibold: 600,
  bold: 700,
  black: 900,
};